import React from "react";
import styles from "./modal.module.css";
import Icon from "../icons/icons";
import Button from "../form/button/button";
import ButtonCancel from "../form/button/button_cancel";
import ieSvg from "../icons/ieSvg";
import ButtonLink from "../form/button/button_link";

class Modal extends React.Component {

  componentDidMount() {
    var dialog = document.querySelectorAll("[data-dialog]");
    dialog.forEach(function (e){
      e.parentElement.className += ' modal-wrapper';
      var dialog = e.childNodes[0];
      var dialogWidth = dialog.scrollWidth/2;
      var dialogHeight = dialog.scrollHeight/2;
      dialog.style.margin = "-" + dialogHeight + "px 0 0 -" + dialogWidth + "px"
    });
    ieSvg();
  }

  render() {
    return (
      <div className={styles.mask} data-dialog>
        <div className={`${styles.dialog} ${this.props.class}`} data-form>
          <span className={styles.close} onClick={this.props.handleClick}>
            <Icon name="icon_close" viewbox="0 0 24 24" />
          </span>
          {this.props.modalIcon?
            <Icon name={this.props.modalIcon}  viewbox={this.props.viewbox} />
            :
            null
          }
          <div className={styles.title}>
            {this.props.title}
          </div>
          <div className={styles.content}>
            {this.props.body}
          </div>
          <div className={this.props.footer}>
            {
              this.props.receiptLink?
                  <span className={styles.link_receipt}>
                    <ButtonLink url={this.props.receiptLink} icon="icon_cheque" text="Посмотреть чек" />
                  </span>
                  :
                  null
            }
            {
              this.props.cancelLink?
                <span onClick={this.props.cancelLink} className={styles.link_cancel}>
                  <ButtonCancel title={this.props.cancelButton} />
                </span>
                :
                null
            }
            {
              this.props.link?
                <span onClick={this.props.link}  className={styles.link_button}>
                  <Button title={this.props.button} />
                </span>
                :
                <span></span>
            }

          </div>
        </div>
      </div>
    )
  }
}

export default Modal;
